<template>
  <v-container>
    <v-row class="mb-4 justify-space-between">
      <v-col align-items-center>
        <h1 class="text text-h4 titulo">
          <v-icon class="mr-2">fas fa-file-invoice-dollar</v-icon>
          {{ isEditing ? 'Editar' : 'Nueva' }} Factura de Compra
          <v-chip
            v-if="isEditing && invoice.estatus"
            :color="getStatusColor(invoice.estatus)"
            text-color="white"
            small
            class="ml-3"
          >
            {{ getStatusName(invoice.estatus) }}
          </v-chip>
        </h1>
      </v-col>
      <v-col class="text-end d-flex justify-end">
        <v-btn class="mr-2" @click="$router.go(-1)">
          <v-icon class="mr-2">fas fa-arrow-left</v-icon>Volver
        </v-btn>
        <v-btn color="success" @click="saveInvoice" :loading="loading">
          <v-icon class="mr-2">fas fa-save</v-icon>Guardar
        </v-btn>
      </v-col>
    </v-row>
    
    <v-card class="pa-6">
          <v-row>
            <!-- Búsqueda de Órdenes -->
            <v-col cols="12">
              <h3 class="text-h6 mb-4">Búsqueda de Órdenes</h3>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="purchase_order_search"
                label="Orden de Compra (Opcional)"
                outlined
                dense
                :append-icon="purchase_order_finded ? 'fas fa-check' : 'fas fa-search'"
                :loading="loadingPurchaseOrder"
                @keydown="searchPurchaseOrder"
                :hint="alertHasInvoices ? ['Ya existe un documento para esta orden de compra'] : []"
                :persistent-hint="alertHasInvoices"
                :disabled="loading"
              >
                <template v-slot:append-outer v-if="purchase_order_finded">
                  <v-icon small @click="clearPurchaseOrder" class="error--text">
                    fas fa-times
                  </v-icon>
                </template>
              </v-text-field>
            </v-col>
            
            <v-col cols="12" md="6">
              <v-text-field
                v-model="work_order_search"
                label="Orden de Trabajo (Opcional)"
                outlined
                dense
                :append-icon="work_order_finded ? 'fas fa-check' : 'fas fa-search'"
                :loading="loadingWorkOrder"
                @keydown="searchWorkOrder"
                :disabled="loading"
              >
                <template v-slot:append-outer v-if="work_order_finded">
                  <v-icon small @click="clearWorkOrder" class="error--text">
                    fas fa-times
                  </v-icon>
                </template>
              </v-text-field>
            </v-col>
            
            <!-- Detalles de la Orden de Trabajo -->
            <v-col cols="12" v-if="work_order_finded">
              <v-textarea
                v-model="work_order_details"
                label="Detalles de la Orden de Trabajo"
                :readonly="true"
                outlined
                dense
                rows="3"
                no-resize
                overflow="auto"
                :loading="loadingWorkOrder"
              ></v-textarea>
            </v-col>
            
            <!-- Información Principal -->
            <v-col cols="12">
              <h3 class="text-h6 mb-4">Información de la Factura</h3>
            </v-col>
            <v-col cols="12" md="6">
              <ValidationProvider name="Documento" rules="required" v-slot="{ errors }">
                <v-text-field
                  v-model="invoice.document_id"
                  label="Número de Documento"
                  outlined
                  dense
                  required
                  :disabled="loading"
                  :error-messages="errors"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            
            <v-col cols="12" md="6">
              <ValidationProvider name="Tipo" rules="required" v-slot="{ errors }">
                <v-select
                  v-model="invoice.tipo"
                  :items="tipos"
                  item-text="text"
                  item-value="value"
                  label="Tipo de Documento"
                  outlined
                  dense
                  required
                  :disabled="loading"
                  :error-messages="errors"
                ></v-select>
              </ValidationProvider>
            </v-col>
            
            <v-col cols="12" md="6">
              <ValidationProvider name="Fecha" rules="required" v-slot="{ errors }">
                <v-text-field
                  v-model="invoice.date_received"
                  label="Fecha de Recepción"
                  type="date"
                  outlined
                  dense
                  required
                  :disabled="loading"
                  :error-messages="errors"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            
            <v-col cols="12" md="6">
              <ValidationProvider name="Condición de Pago" rules="required" v-slot="{ errors }">
                <v-text-field
                  v-model="invoice.payment_condition"
                  label="Condición de Pago (días)"
                  type="number"
                  outlined
                  dense
                  required
                  :disabled="loading"
                  :error-messages="errors"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            
            <!-- Información del Proveedor -->
            <v-col cols="12">
              <h3 class="text-h6 mb-4">Información del Proveedor</h3>
            </v-col>
            
            <v-col cols="12" md="6">
              <ValidationProvider name="RUT" rules="required" v-slot="{ errors }">
                <v-text-field
                  v-model="invoice.rutEmisor"
                  label="RUT Emisor"
                  outlined
                  dense
                  required
                  :disabled="loading"
                  :error-messages="errors"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            
            <v-col cols="12" md="6">
              <ValidationProvider name="Razón Social" rules="required" v-slot="{ errors }">
                <v-text-field
                  v-model="invoice.rznSocEmisor"
                  label="Razón Social"
                  outlined
                  dense
                  required
                  :disabled="loading"
                  :error-messages="errors"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            
                        <v-col cols="12" md="6">
              <ValidationProvider name="IVA" rules="required" v-slot="{ errors }">
                <v-text-field
                  v-model="invoice.iva"
                  label="IVA (%)"
                  type="number"
                  outlined
                  dense
                  required
                  :disabled="loading"
                  :error-messages="errors"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
        

      </v-row>
      
      <!-- Detalles de la Factura -->
      <v-row class="mt-6">
        <v-col cols="12">
          <h3 class="text-h6 mb-4">Detalles de la Factura</h3>
          
          <v-data-table
            :headers="detailHeaders"
            :items="invoice.details"
            item-key="nro_linea"
            :loading="loading"
           
            class=""
            :footer-props="{
              showFirstLastPage: true,
              firstIcon: 'fas fa-angle-double-left',
              lastIcon: 'fas fa-angle-double-right',
              prevIcon: 'fas fa-angle-left',
              nextIcon: 'fas fa-angle-right',
              itemsPerPageOptions: [10, 20, 30, 40, 50,100],
            }"
          >
            <template v-slot:top>
              <div class="d-flex justify-end">
              <v-btn
                color="primary"
                @click="addDetail"
                :disabled="loading"
                class="mb-4 "
              >
                <v-icon class="mr-2">fas fa-plus</v-icon>Agregar Detalle
              </v-btn>
              </div>
            </template>
            
            <template v-slot:item.actions="{ item }">
              <v-icon
                small
                class="error--text"
                @click="removeDetailByItem(item)"
              >
                fas fa-trash
              </v-icon>
            </template>
            
            <template v-slot:item.qty="{ item }">
              <v-text-field
                v-model.number="item.qty"
                type="number"
                dense
                outlined
                hide-details
                @input="calculateTotals"
              ></v-text-field>
            </template>
            
            <template v-slot:item.price="{ item }">
              <v-text-field
                v-model.number="item.price"
                type="number"
                dense
                outlined
                hide-details
                @input="calculateTotals"
              ></v-text-field>
            </template>
            
            <template v-slot:item.total="{ item }">
              {{ (item.qty * item.price).toFixed(2) }}
            </template>
            
            <template v-slot:item.sku="{ item }">
              <v-text-field
                v-model="item.sku"
                dense
                outlined
                hide-details
              ></v-text-field>
            </template>
            
            <template v-slot:item.name="{ item }">
              <v-text-field
                v-model="item.name"
                dense
                outlined
                hide-details
              ></v-text-field>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      
      <!-- Totales -->
      <v-row class="mt-6">
        <v-col cols="12" md="6" offset-md="6">
          <v-card outlined>
            <v-card-text>
              <v-row>
                <v-col cols="6">
                  <strong>Subtotal:</strong>
                </v-col>
                <v-col cols="6" class="text-right">
                  {{ subtotal | moneda }}
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <strong>IVA ({{ invoice.iva }}%):</strong>
                </v-col>
                <v-col cols="6" class="text-right">
                  {{ ivaAmount | moneda }}
                </v-col>
              </v-row>
              <v-divider class="my-2"></v-divider>
              <v-row>
                <v-col cols="6">
                  <strong>Total:</strong>
                </v-col>
                <v-col cols="6" class="text-right">
                  <strong>{{ total | moneda }}</strong>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import { 
  getPurchaseInvoice, 
  createPurchaseInvoice, 
  updatePurchaseInvoice 
} from '@/api/purchases'
import { getPurchase } from '@/api/stocks'
import { getWorkOrder } from '@/api/production'
import notifications from '@/utils/notifications'
import moment from 'moment'

export default {
  name: 'CreatePurchaseInvoice',
  data() {
    return {
      loading: false,
      isEditing: false,
      purchaseOrders: [],
      purchase_order_search: '',
      purchase_order_finded: false,
      loadingPurchaseOrder: false,
      alertHasInvoices: false,
      timer: null,
      work_order_search: '',
      work_order_finded: false,
      work_order_details: '',
      loadingWorkOrder: false,
      workOrderTimer: null,

      
      invoice: {
        document_id: '',
        tipo: 30,
        date_received: new Date().toISOString().substr(0, 10),
        provider: null,
        rutEmisor: '',
        rznSocEmisor: '',
        iva:parseInt(this.$store.getters.getCompany.tax),
        payment_condition: 30,
        estatus: 1, // Por defecto: Recibida
        purchase_order: null,
        work_order: null,
        details: []
      },
      
      detailHeaders: [
        { text: 'Línea', value: 'nro_linea', width: '80px' },
        { text: 'SKU', value: 'sku', width: '120px' },
        { text: 'Nombre', value: 'name' },
        { text: 'Cantidad', value: 'qty', width: '120px' },
        { text: 'Unidad', value: 'unit', width: '100px' },
        { text: 'Precio', value: 'price', width: '120px' },
        { text: 'Total', value: 'total', width: '120px' },
        { text: 'Acciones', value: 'actions', width: '80px', sortable: false }
      ],
      
      tipos: [
        { value: 30, text: 'Factura' },
        { value: 50, text: 'Guia de Despacho' },
        { value: 60, text: 'Nota de Credito' }
      ],
      

    }
  },
  
  computed: {
    subtotal() {
      return this.invoice.details.reduce((sum, detail) => {
        return sum + (detail.qty * detail.price)
      }, 0)
    },
    
    ivaAmount() {
      return this.subtotal * (this.invoice.iva / 100)
    },
    
    total() {
      return this.subtotal + this.ivaAmount
    }
  },
  
  methods: {
    searchPurchaseOrder() {
      // Función para hacer búsqueda lazy
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(async () => {
        this.loadingPurchaseOrder = true
        try {
          const data = await getPurchase(this.purchase_order_search)
          
          this.purchase_order_finded = true
          this.loadingPurchaseOrder = false

          console.log('Orden de compra encontrada:', data)
          console.log('Provider data:', data.provider)
          console.log('Provider name:', data.provider_name)
          console.log('Provider rut:', data.provider_rut)
          console.log('Details:', data.details)
          
          // Asignar la orden de compra encontrada
          this.invoice.purchase_order = data.id
          this.invoice.work_order = data.work_order? data.work_order: null
          
          // Si la orden de compra tiene proveedor, auto-completar datos
          if (data.provider) {
            this.invoice.rutEmisor = data.provider_rut || data.provider.rut || ''
            this.invoice.rznSocEmisor = data.provider_name || data.provider.name || ''
            
            console.log('Datos del proveedor asignados:')
            console.log('RUT:', this.invoice.rutEmisor)
            console.log('Razón Social:', this.invoice.rznSocEmisor)
            
            // Forzar actualización de la vista
            this.$forceUpdate()
          }
          
          // Verificar si ya existen facturas para esta orden de compra
          this.alertHasInvoices = data.has_invoices || false

          this.invoice.iva = data.iva || this.$store.getters.getCompany.tax
          this.work_order_search = data.work_order || null
          this.searchWorkOrder()
          
          // Cargar los detalles de la orden de compra si existen
          if (data.details && data.details.length > 0) {
            this.invoice.details = []
            data.details.forEach(detail => {
              this.invoice.details.push({
                nro_linea: this.invoice.details.length + 1,
                sku: detail.article_sku || detail.sku || '',
                name: detail.article_name || detail.name || '',
                qty: detail.qty || 1,
                unit: detail.article_unit_name || 'UN',
                price: detail.price || 0,
                article: detail.article || null
              })
            })
            console.log('Detalles cargados:', this.invoice.details)
            
            // Forzar actualización de la vista
            this.$forceUpdate()
          }
          
          console.log('Orden de compra encontrada:', data)
        } catch (error) {
          console.error('Error buscando orden de compra:', error)
          this.purchase_order_finded = false
          this.loadingPurchaseOrder = false
          this.alertHasInvoices = false
          
          // Limpiar datos si no se encuentra
          if (this.invoice.purchase_order) {
            delete this.invoice.purchase_order
          }
          
          notifications.showInfo('Orden de Compra no encontrada')
        }
      }, 800)
    },
    
    clearPurchaseOrder() {
      this.purchase_order_search = ''
      this.purchase_order_finded = false
      this.alertHasInvoices = false
      if (this.invoice.purchase_order) {
        delete this.invoice.purchase_order
      }
    },
    
    searchWorkOrder() {
      // Función para hacer búsqueda lazy
      if (this.workOrderTimer) {
        clearTimeout(this.workOrderTimer)
        this.workOrderTimer = null
      }
      this.workOrderTimer = setTimeout(async () => {
        this.loadingWorkOrder = true
        try {
          const data = await getWorkOrder(this.work_order_search)
          
          this.work_order_finded = true
          this.loadingWorkOrder = false
          
          const { customer_name, created_at, name } = data
          this.work_order_details = `${customer_name} ${moment(created_at).format('DD/MM/YYYY')} ${name}`
          
          // Asignar la orden de trabajo encontrada
          this.invoice.work_order = this.work_order_search
          
          console.log('Orden de trabajo encontrada:', data)
        } catch (error) {
          console.error('Error buscando orden de trabajo:', error)
          this.work_order_finded = false
          this.loadingWorkOrder = false
          
          // Limpiar datos si no se encuentra
          if (this.invoice.work_order) {
            delete this.invoice.work_order
          }
          
          notifications.showInfo('Orden de Trabajo no encontrada')
        }
      }, 1000)
    },
    
    clearWorkOrder() {
      this.work_order_search = ''
      this.work_order_finded = false
      this.work_order_details = ''
      if (this.invoice.work_order) {
        delete this.invoice.work_order
      }
    },
    
    getStatusName(status) {
      const statusMap = {
        1: 'Recibida',
        2: 'Pagada',
        3: 'Anulada'
      }
      return statusMap[status] || 'Desconocido'
    },
    
    getStatusColor(status) {
      const colorMap = {
        1: 'info',    // Recibida - Azul
        2: 'success', // Pagada - Verde
        3: 'error'    // Anulada - Rojo
      }
      return colorMap[status] || 'grey'
    },
    
    async loadInvoice() {
      if (this.isEditing && this.$route.params.id) {
        try {
          this.loading = true
          console.log('Cargando factura con ID:', this.$route.params.id)
          const response = await getPurchaseInvoice(this.$route.params.id)
          this.invoice = { ...response }
          
          // Si la factura tiene orden de compra, establecer el valor del buscador
          if (this.invoice.purchase_order) {
            this.purchase_order_search = this.invoice.purchase_order.toString()
            this.purchase_order_finded = true
          }
          
          // Si la factura tiene orden de trabajo, establecer el valor del buscador
          if (this.invoice.work_order) {
            this.work_order_search = this.invoice.work_order.toString()
            this.work_order_finded = true
            // Buscar los detalles de la orden de trabajo
            this.searchWorkOrder()
          }
          
          console.log('Factura cargada:', this.invoice)
        } catch (error) {
          console.error('Error cargando factura:', error)
          notifications.showError('Error cargando factura: ' + error.message)
          // Si hay error, volver al listado
          this.$router.push({ name: 'PurchaseInvoices' })
        } finally {
          this.loading = false
        }
      }
    },
    

    
    addDetail() {
      const newDetail = {
        nro_linea: this.invoice.details.length + 1,
        sku: '',
        name: '',
        qty: 1,
        unit: 'UN',
        price: 0,
        article: null
      }
      this.invoice.details.push(newDetail)
    },
    

    removeDetailByItem(item) {
      // Encontrar el índice real del item en el array
      const index = this.invoice.details.findIndex(detail => detail.nro_linea === item.nro_linea)
      if (index !== -1) {
        this.invoice.details.splice(index, 1)
        // Reordenar números de línea
        this.invoice.details.forEach((detail, idx) => {
          detail.nro_linea = idx + 1
        })
        this.calculateTotals()
      }
    },
    
    calculateTotals() {
      // Los totales se calculan automáticamente en computed
    },
    
    async saveInvoice() {
      // Validaciones manuales
      if (!this.invoice.document_id || this.invoice.document_id.toString().trim() === '') {
        notifications.showError('El número de documento es obligatorio')
        return
      }
      
      if (!this.invoice.tipo) {
        notifications.showError('Debe seleccionar un tipo de documento')
        return
      }
      
      if (!this.invoice.date_received) {
        notifications.showError('La fecha de recepción es obligatoria')
        return
      }
      
      if (!this.invoice.payment_condition || this.invoice.payment_condition < 0) {
        notifications.showError('La condición de pago es obligatoria y debe ser mayor o igual a 0')
        return
      }
      
      if (!this.invoice.rutEmisor || this.invoice.rutEmisor.toString().trim() === '') {
        notifications.showError('El RUT del emisor es obligatorio')
        return
      }
      
      if (!this.invoice.rznSocEmisor || this.invoice.rznSocEmisor.toString().trim() === '') {
        notifications.showError('La razón social del emisor es obligatoria')
        return
      }
      
      if (!this.invoice.iva || this.invoice.iva < 0 || this.invoice.iva > 100) {
        notifications.showError('El porcentaje de IVA es obligatorio y debe estar entre 0% y 100%')
        return
      }
      
      // Validar que existan detalles en la factura
      if (this.invoice.details.length <= 0) {
        notifications.showError('Deben existir elementos en la factura')
        return
      }
      
      // Validar que todos los detalles tengan los campos requeridos
      const invalidDetails = this.invoice.details.filter(detail => 
        !detail.name || detail.qty < 0 || detail.price < 0
      )
      
      if (invalidDetails.length > 0) {
        notifications.showError('Todos los detalles deben tener nombre, cantidad y precio válidos')
        return
      }
      
      // Validar que si hay orden de compra en el campo de búsqueda, debe estar encontrada
      if (this.purchase_order_search && !this.purchase_order_finded) {
        notifications.showError('Debe buscar y encontrar la orden de compra antes de guardar')
        return
      }
      
      // Validar que si hay orden de trabajo en el campo de búsqueda, debe estar encontrada
      if (this.work_order_search && !this.work_order_finded) {
        notifications.showError('Debe buscar y encontrar la orden de trabajo antes de guardar')
        return
      }
      

      
      try {
        this.loading = true
        
        // Limpiar datos antes de enviar
        const dataToSend = { ...this.invoice }

        // Cambiar detalles que no tengan sky por un "-"
        dataToSend.details.forEach(detail => {
          if (!detail.sku) {
            detail.sku = '-'
          }
        })

              // Validar y remover campos nulos o vacíos
      if (!dataToSend.purchase_order || !this.purchase_order_finded) {
        delete dataToSend.purchase_order
      }
      if (!dataToSend.document_id) {
        dataToSend.document_id = ''
      }
      if (!dataToSend.work_order || !this.work_order_finded) {
        delete dataToSend.work_order
      }
        
        console.log('Data a enviar:', JSON.stringify(dataToSend, null, 2))
        
        if (this.isEditing) {
          await updatePurchaseInvoice(this.$route.params.id, dataToSend)
          notifications.showSuccess('Factura actualizada correctamente')
        } else {
          await createPurchaseInvoice(dataToSend)
          notifications.showSuccess('Factura creada correctamente')
        }
        
        this.$router.go(-1)
      } catch (error) {
        console.error('Error guardando factura:', error)
        notifications.showError('Error guardando factura: ' + error.message)
      } finally {
        this.loading = false
      }
    },
    
    async initializeComponent() {
      // Determinar si estamos editando o creando
      const routeId = this.$route.params.id
      this.isEditing = routeId && routeId !== 'new' && routeId !== undefined && routeId !== 'undefined'
      
      console.log('Route ID:', routeId)
      console.log('Route ID type:', typeof routeId)
      console.log('Is Editing:', this.isEditing)
      
      // Ya no cargamos proveedores ni órdenes de compra, usamos buscador
      
      // Si estamos editando, cargar la factura
      if (this.isEditing) {
        await this.loadInvoice()
      }
      
      // Agregar primer detalle si no hay ninguno
      if (this.invoice.details.length === 0) {
        this.addDetail()
      }
    }
  },
  
  async mounted() {
    await this.initializeComponent()
  },
  
  watch: {
    // Watcher para detectar cambios en la ruta
    '$route'(to, from) {
      if (to.params.id !== from.params.id) {
        this.initializeComponent()
      }
    },
    
    // Watcher para limpiar datos cuando se borre el campo de búsqueda
    purchase_order_search(newVal) {
      if (!newVal || newVal === '') {
        this.clearPurchaseOrder()
      }
    },
    
    // Watcher para limpiar datos de orden de trabajo cuando se borre el campo de búsqueda
    work_order_search(newVal) {
      if (!newVal || newVal === '') {
        this.clearWorkOrder()
      }
    }
  }
}
</script> 